import { Brand, createBranded } from '@deltasierra/type-utilities';

export type TemplateCustomMergeFieldId = Brand<number, 'TemplateCustomMergeFieldId'>;
export const TemplateCustomMergeFieldId = createBranded<TemplateCustomMergeFieldId>();
